import { call, put, takeLatest, select, takeEvery, all } from "redux-saga/effects";

import {
  fetchTransaction,
  selectContext,
  fetchContextSuccess,
  fetchTransactionSuccess,
  fetchTransactionError
} from "actions";

import {
  getCurrentContext,
  // getFirstContext,
  getContexts as getExistingContext
} from "selector";

import { ContextTypes, ScenarioTypes } from "constant";

import { getAllContext, getTransactionByContext } from "api";

/**
 * Permet de récupérer les contexts initial et les transactions une fois les contexts présent.
 */
function* getContexts(): any {
  const existingContexts = yield select(getExistingContext);
  // on ne lance la récupération des contexts que si l'on ne la pas déjà fait
  if (existingContexts && existingContexts.length === 0) {
    // récupération des contexts existant
    const contexts = yield call(getAllContext);

    // set des contexts
    yield put(fetchContextSuccess(contexts.data));

    // s'il n'y a pas déjà de contexte de défini, on précharge le premier context
    const defaultContext = yield select(getCurrentContext);
    if (defaultContext === null && contexts.data.length > 0) {
      // pas besoin de lancer le fetch, la selection lance de toute façon une recupération des transactions + info
      yield put(selectContext(contexts.data[0].code as string) as any);
    } else {
      // lancement de la récupération des transaction lié au context
      yield put(fetchTransaction());
    }
  }
}

/**
 * Récupération des transactions
 */
function* getTransaction(): any {
  try {
    // récupération du context courant
    let currentContext = yield select(getCurrentContext);

    // récupération des transactions
    const transactions = yield call(getTransactionByContext as any, currentContext);

    // insertion des transactions
    yield put(fetchTransactionSuccess(transactions.data));
  } catch (e) {
    // en cas d'erreur, on vide la liste
    yield put(fetchTransactionError());
  }
}

/**
 * Permet d'effectuer des actions à chaque changement de context
 */
function* watchSelectContext() {
  yield all([
    // action de récupération des transactions
    put(fetchTransaction())
  ]);
}

/**
 * Permet d'initialiser les différents générateur de redux-saga.
 * différent démarrage sont possibles:
 * - takeLatest pour debounce
 * - takeEvery pour récupérer à chaque appel
 * - throttle pour limiter le nombre d'appel
 */
export default [
  takeLatest(ContextTypes.FETCH_CONTEXT, getContexts),
  takeLatest(ScenarioTypes.FETCH_TRANSACTION, getTransaction),
  takeEvery(ContextTypes.SELECT_CONTEXT, watchSelectContext)
];
